module.exports = __webpack_public_path__ + "static/media/bill_logistics.76a8a0dc.png";